import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SwipelistData, SwipelistOptions, SwipelistState } from '@nhochdrei/angular-swipe-list';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { SpinnerService } from 'src/app/services/spinner.service';
import { WebPushNotificationService } from 'src/app/services/web-push-notification.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  activeAccordionActivityIndex: number | null = null;
  notifications: any[] = [];
  showingNotification: any;
  user: any;

  /*Filter's Variabled */
  order: {};
  limit: number;
  page: number;
  count: number;
  maxPage: number;
  defaultPage = 1;
  defaultLimit = 100;
  defaultOrder = { 'WebPushNotificationHistory.id': 'DESC' };
  filtered = {};
  notificationFilterForm: any;
  /*Filter's Variabled */

  dataArray: SwipelistData[] = [];

  statesToInsert: SwipelistState[] = [
    {
      value: 'delete',
      color: 'rgb(255, 0, 0)', // Red color for delete
      label: 'Delete', // Label text
    },
    {
      value: 'open',
      color: 'rgb(0, 150, 0)', // Green color for open
      label: 'Open', // Label text
    }
  ];

  options: SwipelistOptions = {
    states: this.statesToInsert,
    statePanelWidth: '0px', // Initially hide the panel
    stateFontSize: '12pt',
    colorCenter: 'rgb(196, 183, 109)', // Background color for the list center
    colorStatePanel: 'transparent', // Keep state panel transparent initially
    colorText: 'white',
    borderRadius: '0px',
    height: '60px',
    listFontsize: '12pt',
    minSwipePercent: 30,
    maxSwipePx: 700,
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private webPushNotificationService: WebPushNotificationService,
    private spinnerService: SpinnerService,
  ) { }

  async ngOnInit(){
    this.user = JSON.parse(sessionStorage.getItem('currentUser'));
    this.manageFilterForm();
    await this.filter();
    this.refreshSwipeList();
  }

  async refreshSwipeList() {
    this.dataArray = this.notifications.map((n) => 
      ({
        label: this.showNotificationInfo(n)?.title,
        defaultStartIndex: 0
      })
    );
  }

  manageFilterForm() {
    this.notificationFilterForm = new FormGroup({
      'WenPushNotificationHistory.id': new FormControl(''),
    });
  }

  toggleAccordion(index?: number){
    if (this.activeAccordionActivityIndex === index) {
      this.activeAccordionActivityIndex = null;
    } else {
      this.activeAccordionActivityIndex = index; 
    }
    this.showingNotification = this.notifications[index];
  }

  showNotificationInfo(notification: any) {
    try {
      let parsedData = JSON.parse(notification?.notificationData);
      const token = parsedData?.data?.token;
      const url = parsedData?.data?.url;
      let returnedData = {
        title: parsedData?.title,
        intendUrl: token ? (url + token) : url
      };
      // console.log("returnedData", returnedData)
      return returnedData;
    } catch (error) {
      
    }
  }

  navigate(event) {
    this.loadNotifications(event.limit, event.page, this.order);
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          return 'fa-sort-up';
        case 'DESC':
          return 'fa-sort-down';
        default:
          return 'fa-sort';
      }
    }
  }

  public navigateOrder(attribute: string | string[]) {
    delete this.order['Delivery.updatedAt'];
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          this.order[attr] = 'DESC';
          break;
        case 'DESC':
          this.order[attr] = undefined;
          break;
        default:
          this.order = {}
          this.order[attr] = 'ASC';
          break;
      }
    }

    this.navigatePage(this.limit, this.page, { order: this.order });
  }

  navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(data => {
      this.loadNotifications();
    });
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }

  async filter() {
    try {
      let filterForm = (new FormGroupToObject()).transform(this.notificationFilterForm);
      this.filtered = {};

      if (filterForm['WebPushNotificationHistory.id'])
        this.filtered['WebPushNotificationHistory.id'] = filterForm['WebPushNotificationHistory.id'];

      await this.loadNotifications();
    } catch (error) {
      
    }
  }

  async loadNotifications(limit?: number, page?: number, order?: {}) {
    try {
      this.spinnerService.show();
      let filterForm = (new FormGroupToObject()).transform(this.notificationFilterForm);
      this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
      this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
      this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;
      let notifications = await this.webPushNotificationService.getAllNotifications(this.page, this.limit, this.order, this.filtered);
      this.notifications = notifications.notifications;
      this.count = notifications.count;
      this.maxPage = Math.ceil(this.count / this.limit);
      const notificationIds = this.notifications.map(d => d.id);
      let ids = JSON.stringify(notificationIds);
      await this.webPushNotificationService.markAsRead(ids, this.user.id);
      let notification: {count: number} = await this.webPushNotificationService.getNotificationCount(this.user.id);
      this.webPushNotificationService.updateNotificationCount(notification?.count);
      this.spinnerService.hide();
    } catch (error) {
      this.spinnerService.hide();
      console.log("error", error);
    }
  }

  redirectUser(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }

  async onOutput(event: any) {
    try {
      const index = this.dataArray.findIndex(item => item.label === event.label);
      if (index > -1) {
        const notification = this.notifications[index];
        if (event?.value === 'delete') {
          let result = await this.webPushNotificationService.removeNotificationHistory(notification.id);
          console.log("result", result)
          if(result) {
            this.notifications.splice(index, 1);
            await this.filter();
          }
          await this.refreshSwipeList();
        }
        else if (event?.value === 'open') {
          if (notification.intendUrl) {
            window.open(notification.intendUrl, '_blank');
          }
        }
      }
    } catch (error) {
      
    }
  }

}
